const quarters = [
  {
    key: "2025Q4",
    text: "Trim 4 2025",
    value: "2025Q4"
  },
  {
    key: "2026Q1",
    text: "Trim 1 2026",
    value: "2026Q1"
  },
  {
    key: "2026Q2",
    text: "Trim 2 2026",
    value: "2026Q2"
  },
  {
    key: "2026Q3",
    text: "Trim 3 2026",
    value: "2026Q3"
  },
  {
    key: "2026Q4",
    text: "Trim 4 2026",
    value: "2026Q4"
  }
];

export default quarters;